import { textBold, percentSingleDecimal } from '../download-data-styles';
import { renderMainLeftCell, renderMainRightCell, renderSoftLeftCell, renderSectionHeader, renderRowGaps } from '../helpers';
import format from '_shared_/plugins/format.js';

const $format = format.formatHelpers;

export const renderNewGeoHeaderRow = (title, asOfDate) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(title, textBold);
  rowString += renderSoftLeftCell(asOfDate);
  rowString += `</tr>`;
  return rowString;
};

export const renderNewGeoDataHeaderRow = indexName => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell('Regions');
  rowString += renderMainLeftCell('Fund');
  rowString += renderMainLeftCell(indexName);
  rowString += `</tr>`;
  return rowString;
};

export const renderNewGeoDataRow = region => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(region.RegionLabel ? region.RegionLabel : region.RegionName);
  rowString += renderMainRightCell($format.rawPercent(region.Value, 1), percentSingleDecimal);
  rowString += renderMainRightCell($format.rawPercent(region.IndexValue, 1), percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const newGeoInvestingModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeader(data.sectionLabel);
  moduleString += renderRowGaps(3);
  if (data.equityByDomicile) {
    moduleString += renderNewGeoHeaderRow('Equity Portion Breakdown by Domicile', `% of net assets as of ${data.asOfDate} (updated monthly)`);
    moduleString += renderRowGaps();
    moduleString += renderNewGeoDataHeaderRow(data.indexLabel);
    data.equityByDomicile.forEach(region => {
      moduleString += renderNewGeoDataRow(region);
    });
    moduleString += renderRowGaps(2);
  }
  if (data.equityByRevenue) {
    moduleString += renderNewGeoHeaderRow('Equity Portion Breakdown by Revenue', `% of net assets as of ${data.asOfDate} (updated monthly)`);
    moduleString += renderRowGaps();
    moduleString += renderNewGeoDataHeaderRow(data.indexLabel);
    data.equityByRevenue.forEach(region => {
      moduleString += renderNewGeoDataRow(region);
    });
    moduleString += renderRowGaps(2);
  }
  if (data.strategyByDomicile) {
    moduleString += renderNewGeoHeaderRow('Fund Breakdown by Domicile', `% of net assets as of ${data.asOfDate} (updated monthly)`);
    moduleString += renderRowGaps();
    moduleString += renderNewGeoDataHeaderRow(data.indexLabel);
    data.strategyByDomicile.forEach(region => {
      moduleString += renderNewGeoDataRow(region);
    });
    moduleString += renderRowGaps(2);
  }
  moduleString += renderRowGaps(2);
  return moduleString;
};
